<template lang="pug">
//- v-card(color="white")
  //-   v-list(two-line='')
  //-     v-list-item
  //-       .position-relative
  //-         v-avatar.elevation-1(:size="isMovil ? 50 : 70")
  //-           avatar-perfil(:path="usuario.foto" gradient)
  //-         v-btn.position-absolute.floatt(fab   color="primary white--text", @click="openModalAdjuntar()"  v-if="perfil === 'sistemas' || usuarioLogged === usuario.usuario")
  //-           v-icon edit
  //-       v-list-item-content.ml-3
  //-         v-list-item-title.font-weight-700(v-text='usuario.nombre', :class="isMovil ? 'font-size-17' : 'font-size-17'")
  //-         v-list-item-subtitle( :class="isMovil ? 'font-size-12' : 'font-size-12'")
  //-           span {{usuario.cargo}}
  //-           span(v-if="perfil !== 'usuario-contrato' && perfil !== 'usuario-contrato'") &nbsp; ({{usuario.tipoArea}}/{{usuario.zonaGarantia}})
  //-       v-list-item-action
  //-         v-menu(transition='slide-x-transition' bottom='' right='')
  //-           template(v-slot:activator='{ on, attrs }')
  //-             v-btn.animated.fadeInUp.faster(icon dark  v-bind='attrs' v-on='on' :disabled="perfil === 'supervisor'")
  //-               v-icon  more_vert
  //-           v-list(dense)
  //-             v-list-item( @click="enviarDatosDelUsuario()")
  //-               v-list-item-title
  //-                 | Enviar datos del usuario al SIV
  //-   v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border="left" type='warning')
  //-     .d-flex
  //-       small.font-size-12.font-weight-700 Esta cuenta esta pendiente de aprobación para poder crear tickets
  //-       v-spacer
  //-       v-btn(   color="white warning--text", @click="openModalAdjuntar()"  )
  //-         v-icon check
  //-         small.is-bold Activar cuenta
      //- v-btn(color='success'  block :class="{'mt-4' : isMovil}" :small="!isMovil", @click="fetchAsignarCodigoSap()")
      //-   | Asignar codigo SAP
    //- v-list.py-0.px-0(nav, dense, :class="!isMovil ? 'box-data-user' : 'box-data-movil'")
    //-   v-list-item.px-0.py-0
    //-     v-list-item-content
        //- v-list-item-action
        //-   v-btn( fab small color='primary', )
        //-     v-icon edit
v-list(nav, dense, :class="!isMovil ? 'box-data-user' : 'box-data-movil'")
  v-list-item.px-4(v-if="usuario.codigoSap")
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | account_box
    v-list-item-content
      v-list-item-title Codigo SAP
      v-list-item-subtitle(:class="{'error--text' : !usuario.codigoSap}") {{usuario.codigoSap ? usuario.codigoSap.toUpperCase() : 'No asignado'}}
    v-list-item-action
      v-btn( fab small color='primary', :disabled="perfil === 'supervisor'" @click="habilitarEdicionCodigoSAP()")
        v-icon edit
  v-sheet(:color="showDetailsDataSAP ? '' : 'secondary'", v-else )
    v-list.elevation-4(v-if="showDetailsDataSAP" two-line='', dense color="background")
      v-list-item
        v-btn(color='error'  :block="isMovil" :small="!isMovil", @click="limpiarDatosClienteSAP()")
          v-icon arrow_back
          | Volver
      v-list-item
        v-list-item-content
          v-list-item-title(v-html='datosClienteSAP.nombreCliente')
          v-list-item-subtitle(v-html='datosClienteSAP.direccion')
      v-list-item
        v-btn(color='success'  block :class="{'mt-4' : isMovil}" :small="!isMovil", @click="fetchAsignarCodigoSap()")
          | Asignar codigo SAP
    .d-flex.pa-4(v-else)
      v-text-field(v-model='codigoClienteSAP' solo ref="codigoClienteSAP" @keyup.enter="fetchGetDatosSAP()", :disabled="perfil === 'supervisor'" dense label='Ingresa un codigo SAP para esta cuenta'   hide-details='' clearable='' clear-icon='close')
      v-tooltip(top='')
        template(v-slot:activator='{ on, attrs }')
          v-btn.ml-4(fab, color="info" :disabled="perfil === 'supervisor'" small v-bind='attrs' v-on='on'  @click="fetchGetDatosSAP()")
            v-icon person_search
        small Obtener datos de SAP
  v-divider(inset='')
  v-list-item.px-4(v-if="usuario.telefono")
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | call
    v-list-item-content
      v-list-item-title Telefono
      v-list-item-subtitle(:class="{'error--text' : !usuario.telefono}") {{usuario.telefono ? usuario.telefono : 'No asignado'}}
    v-list-item-action
      v-btn( fab small color='primary', :disabled="perfil === 'supervisor'" @click="habilitarEdicionTelefono")
        v-icon edit
  v-sheet(:color="showTelefonoCliente ? '' : 'secondary'", v-else)
    v-list.elevation-4(v-if="showTelefonoCliente" two-line='', dense color="background")
      v-list-item
        v-btn(color='error'  :block="isMovil" :small="!isMovil", @click="limpiarDatosTelefonoCliente()")
          v-icon arrow_back
          | Volver
      v-list-item
        v-list-item-content
          v-list-item-title(v-html='datosClienteSAP.nombreCliente')
          v-list-item-subtitle(v-html='datosClienteSAP.direccion')
      v-list-item
        v-btn(color='success'  block :class="{'mt-4' : isMovil}" :small="!isMovil", )
          | Asignar codigo SAP
    .d-flex.pa-4(v-else)
      v-text-field(v-model='numeroTelefonoCliente' ref="numeroTelefonoCliente" ,  solo :disabled="perfil === 'supervisor'" dense label='Ingresa un numero de telefono para enlazar este usuario' hide-details='' clearable='' clear-icon='close')
      v-tooltip(top='')
        template(v-slot:activator='{ on, attrs }')
          v-btn.ml-4(fab, color="info " :disabled="perfil === 'supervisor'" small v-bind='attrs' v-on='on'  @click="fetchSaveDatosCliente()")
            v-icon check
        small Guardar cambios
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | apartment
    v-list-item-content
      v-list-item-title Entidad
      v-list-item-subtitle(:class="{'error--text' : !usuario.entidad}") {{usuario.entidad ? usuario.entidad.toUpperCase() : 'No definido'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | alternate_email
    v-list-item-content
      v-list-item-title Usuario / Email
      v-list-item-subtitle {{usuario.usuario}}
  v-divider(inset='')
  v-list-item.px-4(v-if="usuario.entidad === 'empresa'")
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | badge
    v-list-item-content
      v-list-item-title Razon Social
      v-list-item-subtitle {{usuario.razonSocial}}
  v-divider(inset='' v-if="usuario.entidad === 'empresa'")
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | person
    v-list-item-content
      v-list-item-title(v-if="usuario.entidad === 'empresa'") Nombre contacto
      v-list-item-title(v-else) Nombre
      v-list-item-subtitle(:class="{'error--text' : !usuario.nombre}") {{usuario.nombre}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | portrait
    v-list-item-content
      v-list-item-title(v-if="usuario.entidad === 'empresa'") Documento contacto
      v-list-item-title(v-else) Documento
      v-list-item-subtitle(:class="{'error--text' : !usuario.documento}") {{usuario.documento ? usuario.documento : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | work
    v-list-item-content
      v-list-item-title(v-if="usuario.entidad === 'empresa'") Cargo contacto
      v-list-item-title(v-else) Cargo
      v-list-item-subtitle(:class="{'error--text' : !usuario.cargo}") {{usuario.cargo ? usuario.cargo : 'No asignado'}}
  v-divider(inset='')

  v-list-item.px-4(v-if="usuario.entidad === 'empresa'")
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | gavel
    v-list-item-content
      v-list-item-title RUC
      v-list-item-subtitle(:class="{'error--text' : !usuario.ruc}") {{usuario.ruc ? usuario.ruc : 'No asignado'}}
  v-divider(inset='' v-if="usuario.entidad === 'empresa'")
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | place
    v-list-item-content
      v-list-item-title Direccion
      v-list-item-subtitle(:class="{'error--text' : !usuario.direccion}") {{usuario.direccion ? usuario.direccion : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | circle
    v-list-item-content
      v-list-item-title Ubigeo
      v-list-item-subtitle(:class="{'error--text' : !usuario.ubigeo}") {{usuario.ubigeo ? usuario.ubigeo : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | circle
    v-list-item-content
      v-list-item-title Departamento
      v-list-item-subtitle(:class="{'error--text' : !usuario.departamento}") {{usuario.departamento ? usuario.departamento : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | circle
    v-list-item-content
      v-list-item-title Provincia
      v-list-item-subtitle(:class="{'error--text' : !usuario.provincia}") {{usuario.provincia ? usuario.provincia : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | circle
    v-list-item-content
      v-list-item-title Distrito
      v-list-item-subtitle(:class="{'error--text' : !usuario.distrito}") {{usuario.distrito ? usuario.distrito : 'No asignado'}}
  v-divider(inset='')
  v-list-item.px-4
    v-list-item-icon
      v-icon(color='primary' :size="23")
        | folder_shared
    v-list-item-content
      v-list-item-title Acepta compartir sus datos personales
      v-list-item-subtitle {{usuario.aceptaPoliticasDeprivacidad ? 'SI' : 'NO'}}
</template>
<script>
import { apiGet, notify, apiPost } from '../util/general'
import avatarPerfil from '@/components/c_avatar_perfil'
export default {
  name      : 'c_card_informacion_usuario',
  components: {
    'avatar-perfil': avatarPerfil
  },
  props : {
    datos : {
      type: Object
    },
    descargarsctr : {
      type   : Boolean,
      default: false
    },
    showDetails : {
      type   : Boolean,
      default: false
    },
    isFetch : {
      type   : Boolean,
      default: false
    },
    onlyTecnicos : {
      type   : Boolean,
      default: false
    },
    codigoTecnico : {
      type   : Number,
      default: 0
    },
    username : {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      usuario           : this.datos || {},
      isDescargar       : this.descargarsctr,
      isLoading         : false,
      showInfoUser      : false,
      showTelefonoCliente      : false,
      codigoClienteSAP  : '',                             // C20100131359
      numeroTelefonoCliente  : '',
      datosClienteSAP   : null,
      showDetailsDataSAP: false,
      sivWebCliente     : process.env.SIV_WEB_ROUTE,
      perfil            : localStorage.getItem('perfil')
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  created () {
    var vm = this
    if (vm.isFetch) vm.fetchUsuario()
  },
  methods : {
    enviarDatosDelUsuario () {
      var vm = this
      var query = ``
      Object.keys(vm.usuario).forEach(e => {
        if (e !== 'foto' && e !== 'password' && e !== 'emailConfirmado' && e !== 'rutaSctr' && e !== 'resetToken' && e !== 'tokenVerifyEmail' && e !== 'direccion') {
          query += `${e}=${vm.usuario[e]}&`
        }
      })
      var ruta = `${vm.sivWebCliente}/#/cliente-administrador?${query}`
      window.open(ruta, '_blank')
    },
    habilitarEdicionCodigoSAP () {
      var vm = this
      vm.codigoClienteSAP    = vm.usuario.codigoSap
      vm.usuario.codigoSap = ''
      vm.showDetailsDataSAP = false
    },
    habilitarEdicionTelefono () {
      var vm = this
      vm.numeroTelefonoCliente    = vm.usuario.telefono
      vm.usuario.telefono = ''
      vm.showTelefonoCliente = false
    },
    limpiarDatosClienteSAP () {
      var vm                = this
      vm.showDetailsDataSAP = false
      vm.datosClienteSAP    = null
    },
    limpiarDatosTelefonoCliente () {
      var vm                = this
      vm.showTelefonoCliente = false
      vm.numeroTelefonoCliente    = null
    },
    fetchDescargarSCTR () {
      var vm = this
      if (!vm.usuario.rutaSctr) notify(vm, 'error', 'Error', 'No cuenta con el SCTR actualizado')
      else window.open(vm.usuario.rutaSctr, '_blank')
    },
    fetchUsuario () {
      var vm       = this
      vm.isLoading = true
      var obj      = {}
      if (vm.username) obj.usuario = vm.username
      else if (vm.codigoTecnico > 0) obj.codigoTecnico = vm.codigoTecnico

      apiGet(vm, '/usuario/obtener', obj, function (data) {
        vm.usuario = data.lista[0] || {}
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    fetchSaveDatosCliente () {
      var vm       = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Asignando numero de telefono' })
      var obj = {
        usuario  : vm.usuario.usuario,
        numeroTelefono: vm.numeroTelefonoCliente
      }
      apiPost(vm, '/usuario/actualizar/numero/telefono', obj, function (data) {
        notify(vm, 'success', 'Exito', 'La asignación del telefono se realizo de manera exitosa')
        vm.usuario.telefono = vm.numeroTelefonoCliente
        vm.limpiarDatosTelefonoCliente()
        vm.numeroTelefonoCliente = ''
        // vm.fetchUsuario()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchGetDatosSAP () {
      var vm       = this
      if (!vm.codigoClienteSAP) {
        notify(vm, 'error', 'Error', 'Ingrese el codigo de cliente SAP')
        vm.$refs.codigoClienteSAP.focus()
        return
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo informacion de SAP' })
      var obj      = {
        codigoCliente : vm.codigoClienteSAP
      }

      apiGet(vm, '/cliente/obtener/sap', obj, function (data) {
        var lista = data.lista[0]
        if (lista.codigoSAP === vm.codigoClienteSAP) {
          vm.datosClienteSAP = lista
          vm.showDetailsDataSAP = true
        } else vm.showDetailsDataSAP = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchAsignarCodigoSap () {
      var vm = this
      var obj = {
        usuario  : vm.usuario.usuario,
        codigoSap: vm.codigoClienteSAP
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Asignando codigo SAP' })
      apiPost(vm, '/usuario/actualizar/codigo/sap', obj, function (data) {
        notify(vm, 'success', 'Exito', 'La asignación del codigo SAP se realizo de manera exitosa')
        vm.usuario.codigoSap = vm.codigoClienteSAP
        vm.limpiarDatosClienteSAP()
        vm.codigoClienteSAP = ''
        // vm.fetchUsuario()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.sticky
  position sticky
  top 0px
  z-index 1
.box-data-user
  height: calc(100vh - 240px);
  overflow-y: scroll;
.box-data-movil
  height: calc(100vh - 250px);
  overflow-y: scroll;
</style>



// WEBPACK FOOTER //
// c_card_informacion_usuario.vue?df23b932